import { BaseItem } from './common';

export type Query = Partial<{
  ehrInformationId: string;
  encounterId: string;
  patientOrderId: string;
}>;

export enum EventType {
  Action = 'Action',
  Entity = 'Entity',
  Fingerprint = 'Fingerprint',
  Form = 'Form',
  Job = 'Job',
  Notification = 'Notification',
}

export interface EventV2 {
  created: Date;
  type: EventType;
  name: string;
  status: string;
  tags: string[];
  metadata: object;
  hasCustomMetadata?: boolean;

  // statusPriority values must match design-system BadgeVariant values
  statusPriority?: 'success' | 'warning' | 'danger' | 'pending' | 'primary';
}

// DEPRECATED

export enum Kind {
  FormInitialized = 'FORM_INITIALIZED',
  FormUpdated = 'FORM_UPDATED',
  FormStatusUpdate = 'FORM_STATUS_UPDATE',
}

export enum Target {
  DeviceAction = 'DEVICE_ACTION',
  EncounterEvent = 'ENCOUNTER_EVENT',
  Fingerprint = 'FINGERPRINT',
  OrderEvent = 'ORDER_EVENT',
  Notification = 'NOTIFICATION',
  PatientEvent = 'PATIENT_EVENT',
  PrevisitForm = 'PREVISIT_FORM',
  PrevisitLog = 'PREVISIT_LOG',
  VisitStatus = 'VISIT_STATUS',
  Workflow = 'WORKFLOW',
}

export interface Event {
  created: Date;
  event: string;
  description: string[];
  kind?: Kind;
  target?: Target;
  foldable?: boolean;
  metadata?: any;
}

export interface FormFieldEvent extends Event {
  kind: Kind;
  previsitFormTemplateId: string;
  label: string;
  from: string;
  to?: string;
}

export interface FormEvent extends Event {
  kind: Kind;
  previsitFormId: string;
  previsitFormTemplateName: string;
  previsitFormFieldEvents: FormFieldEvent[];
  previsitFormTemplateId: string;
}

export interface FormFieldUpdate extends BaseItem {
  previsitFormFieldId: string;
  value: string;
  previsitFormTemplateId: string;
  previsitFormTemplateName: string;
  previsitFormId: string;
  label: string;
}

export interface Form extends BaseItem {
  name: string;
  displayName: string;
  events: FormFieldUpdate[];
  previsitFormSetId: string;
  previsitFormTemplateId: string;
  startedTimestamp: string;
  completedTimestamp: string;
  source: string;
}

export interface JobEvent {
  jobId?: string;
  isSuccessful?: boolean;
  feedId?: string;
  failureReason?: string;
  ehr?: string;
  messageId?: string;
  workerName?: string;
  screenshotGsPaths?: string[] | null;
  videoGsPath?: string | null;
  totalTime?: string;
  processingTime?: string;
}
